// store/modules/eshopKanban.js
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { useToast } from 'vue-toastification'

const toast = useToast()
const statusToColumnName = {
  new: 'Новые',
  typo_finish: 'Типография(тираж)',
  in_progress: 'Типография(тираж)',  
  wap: 'Типография(ППР)',
  stock: 'Склад(типография)',
  done: 'Отправлено',
}

export default {
  namespaced: true,
  state: {
    isLoading: false,
    columns: [
      {
        id: uuidv4(),
        name: 'Новые',
        name_ru: 'Новые',
        name_kz: 'Кезек',
        name_en: 'New',
        color: '#F59E0B', // amber
        orders: []
      },
       {
        id: uuidv4(),
       name: 'Типография(тираж)',
        name_ru: 'Типография(тираж)',
        name_kz: 'Баспа(тираж)',
        name_en: 'Printing (Circulation)',
        color: '#F59E0B', // amber
        orders: []
      },
        {
        id: uuidv4(),
        name: 'Типография(ППР)',
        name_ru: 'Типография(ППР)',
        name_kz: 'Баспа(БКЖ)',
        name_en: 'Printing (WAP)',
        color: '#F59E0B', // amber
        orders: []
      },
       {
        id: uuidv4(),
        name: 'Склад(типография)',
        name_ru: 'Склад(типография)',
        name_kz: 'Қойма(баспа)',
        name_en: 'Stock(Printing House)',
        color: '#F59E0B', // amber
        orders: []
      },
      {
        id: uuidv4(),
        name: 'Отправлено',
        name_ru: 'Отправлено',
        name_kz: 'Жөнелтілді',
        name_en: 'Sent',
        color: '#3B82F6', // blue
        orders: []
      },
      // на будущее:
      // {
      //   id: uuidv4(),
      //   name: 'Доставлено',
      //   name_ru: 'Доставлено',
      //   name_kz: 'Жеткізілді',
      //   name_en: 'Delivered',
      //   color: '#10B981', // green
      //   orders: []
      // },
    ],
  },
  getters: {
    columns: (state) => state.columns,
  },
  mutations: {
    SET_LOADING(state, v) { state.isLoading = v },
    SET_ERROR(_, err) {
      const message = err?.response?.data?.message || err?.message || 'Unknown error'
      toast.error(`Error: ${message}`, { timeout: 2000 })
    },
    
    SET_COLUMNS_FROM_ORDERS(state, orders) {
      state.columns.forEach((c) => (c.orders = []))
      orders.forEach((o) => {
        const colName = statusToColumnName[o.status]
        if (!colName) return
        state.columns.find((c) => c.name === colName)?.orders.push(o)
      })
    },

    UPDATE_ORDER_IN_COLUMNS(state, updated) {
      // удалить из всех колонок
      state.columns.forEach((c) => {
        c.orders = c.orders.filter((o) => o.id !== updated.id)
      })

      // добавить в целевую колонку по статусу
      const colName = statusToColumnName[updated.status]
      if (!colName) return
      state.columns.find((c) => c.name === colName)?.orders.push(updated)
    },
  },
  actions: {
    async fetchOrders({ commit }) {
      commit('SET_LOADING', true)
      try {
        const token = localStorage.getItem('token')
        const { data } = await axios.get('https://apidash.smartpress.kz/api/shop-orders', {
          headers: { Authorization: `Bearer ${token}` }
        })
        commit('SET_COLUMNS_FROM_ORDERS', data.orders || [])
      } catch (e) {
        commit('SET_ERROR', e)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // перетаскивание меняет статус
    async updateShopOrderKanban({dispatch, commit }, { id, status }) {
      try {
        const token = localStorage.getItem('token')
        // Ожидаемый эндпоинт. Если его нет — создайте на бэкенде:
        // Route::post('/shop-orders/{order}/status', ...) => { order, status }
        const { data } = await axios.post(
          `https://apidash.smartpress.kz/api/shop-orders/${id}/status`,
          { status },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        // ответ должен вернуть обновлённый order
        commit('UPDATE_ORDER_IN_COLUMNS', data.order || { id, status })

        await dispatch('fetchOrders')
              
        toast.success('Статус обновлён', { timeout: 1600 })
      } catch (e) {
        // если серверного эндпоинта ещё нет — откатится drag автоматически,
        // т.к. в state мы не вносили изменений до успешного ответа
        toast.error('Не удалось обновить статус', { timeout: 1600 })
        throw e
      }
    },
  },
}
